import CompanyNotFoundRoute from './company-not-found.route';
import RouteNames from '../constants/route-names';

const route = {
  path: '/',
  name: RouteNames.Home,
  redirect: { name: CompanyNotFoundRoute.name },
};

export default route;
